export default "__VITE_ASSET__CQ19lpMW__"